exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-acopio-container {\n  position: relative;\n  padding: 20px; }\n  .main-acopio-container .close-button {\n    position: absolute;\n    top: 0;\n    right: 0; }\n\n.list-container {\n  width: 100%;\n  border-top: 1px solid #ddd;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n  .list-container .acopio-item {\n    border-bottom: 1px solid #ddd;\n    height: 58px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    -ms-flex-align: center;\n        align-items: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/administracion/remitos/common/remito-acopio-selector-autocomplete-dialog/remito-acopio-selector-autocomplete-dialog.component.scss
// module id = ../../../../../src/app/components/administracion/remitos/common/remito-acopio-selector-autocomplete-dialog/remito-acopio-selector-autocomplete-dialog.component.scss
// module chunks = 0